// extracted by mini-css-extract-plugin
module.exports = {"signin-social":"SigninSocial_signin-social__38Fbg"};